import { Component, Input } from '@angular/core';
import { Order } from 'src/app/core/orders.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-order-details-qinetic-position',
  templateUrl: './order-details-qinetic-position.component.html',
  styleUrls: ['./order-details-qinetic-position.component.scss'],
})
export class OrderDetailsQineticPositionComponent {
  @Input() order?: Order;

  constructor(private utils_service: UtilsService) {}

  getFormattedFee(order?: Order): string {
    if (order?.amount?.sp_total_fee != null) {
      const order_amount = order.amount.sp_total_fee / 100;

      const formatted_amount = order_amount.toLocaleString('it-IT', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      const order_currency = this.getCurrencyLabel(order);

      return `${formatted_amount} ${order_currency}`;
    } else {
      return '-';
    }
  }

  getFormattedNet(order?: Order): string {
    if (order?.amount?.net != null) {
      const order_amount = order.amount.net / 100;

      const formatted_amount = order_amount.toLocaleString('it-IT', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      const order_currency = this.getCurrencyLabel(order);

      return `${formatted_amount} ${order_currency}`;
    } else {
      return '-';
    }
  }

  getCurrencyLabel(order: Order): string {
    return this.utils_service.getCurrencyLabelFromOrder(order);
  }
}
